// extracted by mini-css-extract-plugin
export default {"caption":"PhuHuynhChildList_caption__eQVTl","list_horizontal":"PhuHuynhChildList_list_horizontal__jtEb+","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__srXcX"};